export enum TeamType {
    Normal = 1,
    Grot = 2
}

export const TeamTypeLabels = {
    [TeamType.Normal]: "Avverkning",
    [TeamType.Grot]: "Grot"
};